export const DRIVER_PLANNING_UPDATED_EVENT = "driver-planning-updated";
export const DRIVER_PLANNING_UPDATED_STORAGE_KEY = "driver-planning-updated-at";

export function emitDriverPlanningUpdated(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(DRIVER_PLANNING_UPDATED_EVENT));
  try {
    window.localStorage.setItem(
      DRIVER_PLANNING_UPDATED_STORAGE_KEY,
      String(Date.now())
    );
  } catch {
    // Ignore storage errors (private mode, quota, etc.)
  }
}

